import { render, staticRenderFns } from "./BjzxDetail.vue?vue&type=template&id=7701f652&scoped=true"
import script from "./BjzxDetail.vue?vue&type=script&lang=js"
export * from "./BjzxDetail.vue?vue&type=script&lang=js"
import style0 from "./BjzxDetail.vue?vue&type=style&index=0&id=7701f652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7701f652",
  null
  
)

export default component.exports